// extracted by mini-css-extract-plugin
export default {"completedLayout":"U2iNsMIMBRUkmWQcpC2g"};